import { NewPurchaseOrder } from 'state/handsell';
import { core } from '@tock/coretypes';

export const didPurchasePriceIncreaseFromZero = (
  pastPurchase?: core.IPastPurchase,
  purchaseOrder?: NewPurchaseOrder
) =>
  pastPurchase?.ticketPriceInformation?.amountCents === 0 &&
  (purchaseOrder?.ticketPriceInformation?.amountCents ?? 0) > 0;
